import { render } from "./tiny-mce.vue?vue&type=template&id=80d51cec"
import script from "./tiny-mce.vue?vue&type=script&lang=js"
export * from "./tiny-mce.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__